import {Redirect, Route, Switch, useRouteMatch} from 'react-router-dom';
import {Box, SxProps} from '@mui/material';
import {useOffice} from '../../../../../../contexts/office/context';
import {GenericCollapsibleSidePanel} from '../../../../../../components/generic-collapsible-side-panel/generic-collapsible-side-panel';
import {DashboardSidePanelComponents} from '../../../../../../components/generic-collapsible-side-panel/dashboard-side-panel-components';
import ActivityProfessionalCaregiverOfficeScreen from '../activity/activity.professional-caregiver.screen';
import StatisticsProfessionalCaregiverOfficeScreen from '../statistics/statistics.professional-caregiver.screen';
import {ScreenPaths} from '../../../../../../enums';
import {RolePermissionType} from '../../../../../../backend/enums/role-permission-type';
import PermissionsRequiredRoute from '../../../../../../components/permissions-required-route';
import {useAuth} from '../../../../../../contexts/auth/context';
import {useMemo} from 'react';

export default function DashboardProfessionalCaregiverOfficeScreen() {
  let {path, url} = useRouteMatch();
  const officeContext = useOffice();
  const {hasReadPermission} = useAuth();

  const outterWrapperSx: SxProps = {
    display: 'flex',
    flexDirection: 'row',
  };

  const innerWrapperSx: SxProps = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  };

  const showProfesionalCaregiverOverviewOptions = useMemo(
    () =>
      hasReadPermission(RolePermissionType.Overview_Activity) ||
      hasReadPermission(RolePermissionType.Overview_Statistics),
    [hasReadPermission]
  );

  return (
    <Box sx={outterWrapperSx}>
      {showProfesionalCaregiverOverviewOptions && (
        <GenericCollapsibleSidePanel>
          <DashboardSidePanelComponents
            showExpanded={!officeContext.state.sideNavigationDrawerCollapsed}
          />
        </GenericCollapsibleSidePanel>
      )}
      <Box sx={innerWrapperSx}>
        <Switch>
          <PermissionsRequiredRoute
            exact
            path={`${path}${ScreenPaths.ProfessionalCaregiver_Activity}`}
            requiredPermissions={[
              {
                type: RolePermissionType.Overview_Activity,
                canRead: true, // users must be able to at least read overview activity to access the page
              },
            ]}
          >
            <ActivityProfessionalCaregiverOfficeScreen />
          </PermissionsRequiredRoute>
          <PermissionsRequiredRoute
            exact
            path={`${path}${ScreenPaths.ProfessionalCaregiver_Statistics}`}
            requiredPermissions={[
              {
                type: RolePermissionType.Overview_Statistics,
                canRead: true, // users must be able to at least read overview statistics to access the page
              },
            ]}
          >
            <StatisticsProfessionalCaregiverOfficeScreen />
          </PermissionsRequiredRoute>
          {/* Default */}
          <Route path={path}>
            <Redirect to={`${url}${ScreenPaths.ProfessionalCaregiver_Activity}`} />
          </Route>
        </Switch>
      </Box>
    </Box>
  );
}
